import { SelectPhone } from "@corporate-tailwind/model";

export const COUNTRIES: SelectPhone[] = [
  { id:1, code: 'BE', label: 'Belgium',           labelLCode: null, dialCode: '32', mask: '### ## ## ##', imgPath:'images/flags/be.svg' , availability: {reason: null, isAvailable: true} },
  { id:2, code: 'FR', label: 'France',            labelLCode: null, dialCode: '33', mask: '## ## ## ## ##', imgPath:'images/flags/fr.svg', availability: {reason: null, isAvailable: true}  }
];